const BRL_FORMATTER = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export function parseMoneyBRL(value) {
  if (value == null) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  const raw = String(value).trim();
  if (!raw) return null;

  let cleaned = raw.replace(/\s|\u00A0/g, "").replace(/R\$/gi, "");
  cleaned = cleaned.replace(/[^\d.,-]/g, "");
  if (!cleaned || cleaned === "-") return null;

  if (cleaned.includes(",")) {
    cleaned = cleaned.replace(/\./g, "").replace(",", ".");
  } else {
    const parts = cleaned.split(".");
    if (parts.length > 2) {
      const decimal = parts.pop();
      cleaned = `${parts.join("")}.${decimal}`;
    }
  }

  const numberValue = Number(cleaned);
  return Number.isFinite(numberValue) ? numberValue : null;
}

export function formatMoneyBRL(value) {
  const numberValue = parseMoneyBRL(value);
  return numberValue == null ? "" : BRL_FORMATTER.format(numberValue);
}

export function maskMoneyBRL(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (!digits) return "";
  const numberValue = Number(digits) / 100;
  return BRL_FORMATTER.format(numberValue);
}


/**
 * Rotulo curto para eixo de grafico: "15 mil", "1,2 mi".
 *
 * O eixo tinha largura fixa de 44px e cortava "R$ 15.000,00" pela esquerda, virando ".000,00".
 * Alargar resolveria, mas roubaria espaco do grafico em tela estreita; o rotulo curto resolve nos
 * dois casos. O valor cheio continua no tooltip.
 */
export function formatCompactBRL(value) {
  const numero = Number(value);
  if (!Number.isFinite(numero)) return "";
  const absoluto = Math.abs(numero);
  if (absoluto >= 1_000_000) {
    return `${(numero / 1_000_000).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} mi`;
  }
  if (absoluto >= 1_000) {
    return `${(numero / 1_000).toLocaleString("pt-BR", { maximumFractionDigits: 0 })} mil`;
  }
  return numero.toLocaleString("pt-BR", { maximumFractionDigits: 0 });
}
